"use strict";
import f from "./index.es332.js";
import m from "./index.es333.js";
function a(r, o, t) {
  let e = !f(o);
  return r && (e || t == !1) ? m(r, o) : o;
}
export {
  a as default
};
//# sourceMappingURL=index.es238.js.map
